/*
 * MP-Fader jQuery plugin
 * @category jQuery plugin
 * @copyright (c) mpunkt
 * @author reinhard naegler
 * @version 0.7
 */

/*
// Code Sample:
<div class="mpfader" style="width:500px;">
	<div><img alt="" src="image01.jpg" /></div>
	<div><img alt="" src="image02.jpg" /></div>
	<div><img alt="" src="image03.jpg" /></div>
</div>
<script type="text/javascript">
	$(document).ready(function(){
		$('.mpfader').mpfader();
	});
</script>
*/

(function($){
	$.fn.mpfader = function(options){
		var options = $.extend($.fn.mpfader.defaults, options);
		return this.each(function(){

			$.fn.mpfader.collection[$.fn.mpfader.collection.length] = this;

			// Variablen für nur für diese Instanz geltend
			var self = this;
			var timeInterval = 0;
			var activeElement;
			var nextElement;
			var active_num = 0;
			var backward = false;
			var animating = false;
			var touchLastX;
			var scrollLastY;

			// Hier alle Werte die übergeben werden können für diese Instanz definieren
			var autoStart 		= options.autoStart;
			var keyNavigation 	= options.keyNavigation;
			var delay 			= options.delay;
			var effectDuration 	= options.effectDuration;
			var fitHeight 		= options.fitHeight;
			var randomEffects 	= options.randomEffects;
			var elements 		= $(options.elements, $(self));
			var buttonStop 		= options.buttonStop;
			var buttonNext 		= options.buttonNext;
			var buttonPrev 		= options.buttonPrev;
			var buttonPage 		= options.buttonPage;
			var buttonPageAct 	= options.buttonPageAct;
			var mouseStop		= options.mouseStop;

			// Diese Werte sind von außen ansprechbar und veränderbar
			self.effect 		= options.effect;
			self.key_navigation = keyNavigation; 

			self.stop = function(){
				clearTimeout(timeInterval);
			};

			self.jumpTo = function(index){
				if(animating == true || $(elements).length < 2) return;
				if(index == active_num) return false;

				if($(elements).eq(index).length){
					activeElement = $(elements).eq(active_num);
			    	nextElement = $(elements).eq(index);
					if(active_num < index) backward = false;
					if(active_num > index) backward = true;
					active_num = index;
					self.change();
				}
				return false;
			};

			self.next = function(){
				if(animating == true || $(elements).length < 2) return;
				backward = false;
				activeElement = $(elements).eq(active_num);

				if($(activeElement).next().length){
			    	nextElement = $(elements).eq(active_num).next();
					active_num++;
				} else {
					nextElement = $(elements).eq(0);
					active_num = 0;
				}
				self.change();
				return false;
			};

			self.prev = function(){
				if(animating == true || $(elements).length < 2) return;
				backward = true;
				activeElement = $(elements).eq(active_num);

				if($(activeElement).prev().length){
			    	nextElement = $(elements).eq(active_num).prev();
					active_num--;
				} else {
					nextElement = $(elements).eq($(elements).length - 1);
					active_num = $(elements).length - 1;
				}
				self.change();
				return false;
			};

			self.change = function(){
				if(fitHeight === true){
					// Animierte Höhenänderung
				    $(self).css({height: activeElement.outerHeight()+'px'});
				    $(self).animate({height: nextElement.outerHeight()+'px'}, effectDuration);
				}
				activeElement.css({zIndex: 9, position: 'relative'});

				var eff = (self.effect == 'rand' ? randomEffects[Math.floor(Math.random() * randomEffects.length)] : self.effect);

				if(eff == 'blind-x'){
					if(backward == true){
						act_eff = [];
						next_eff = [{left: '-100%', zIndex: 10}, {left: '0'}];
					} else {
						act_eff = [];
						next_eff = [{left: '100%', zIndex: 10}, {left: '0'}];
					}
				}
				else if(eff == 'blind-y'){
					if(backward == true){
						act_eff = [];
						next_eff = [{top: '100%', zIndex: 10}, {top: '0'}];
					} else {
						act_eff = [];
						next_eff = [{top: '-100%', zIndex: 10}, {top: '0'}];
					}
				}
				else if(eff == 'slide-x'){
					if(backward == true){
						act_eff = [{left: '0'}, {left: '100%'}];
						next_eff = [{left: '-100%', zIndex: 10}, {left: '0'}];
					} else {
						act_eff = [{left: '0'}, {left: '-100%'}];
						next_eff = [{left: '100%', zIndex: 10}, {left: '0'}];
					}
				}
				else if(eff == 'slide-y'){
					if(backward == true){
						act_eff = [{top: '0', position: 'absolute'}, {top: '-100%'}];
						next_eff = [{top: '100%', zIndex: 10, position: 'relative'}, {top: '0'}];
					} else {
						act_eff = [{top: '0', position: 'absolute'}, {top: '100%'}];
						next_eff = [{top: '-100%', zIndex: 10, position: 'relative'}, {top: '0'}];
					}
				}
				else {
					act_eff = [];
					next_eff = [{opacity: 0, zIndex: 10}, {opacity: 1.0}];
				}

				animating = true;
				if(act_eff.length) activeElement.css(act_eff[0]).animate(act_eff[1], effectDuration);
				nextElement.show().css(next_eff[0]).animate(next_eff[1], effectDuration, function(){
		            activeElement.hide().css({zIndex: 8, top: '0', left: '0', position: 'absolute'});
					nextElement.css({position: 'relative'});
					animating = false;
		        });

				self.checkNav();
				clearTimeout(timeInterval);
				if(autoStart === true) {
					timeInterval = setTimeout((backward == true ? self.prev : self.next), delay);
				}
			};

			self.checkNav = function(){
				$(buttonPage).removeClass(buttonPageAct);
				$(buttonPage).each(function(){
					var jto = $(this).attr('href').replace('#','');
					if(jto == active_num) $(this).addClass(buttonPageAct);
				});
			}

			// Initialisierung...

			$(self).css({
				position: 'relative',
				overflow: 'hidden'
			});

			$(elements)
				.each(function(i){
					if($(this).is('visible')){ active_num = i; activeElement = $(this); return false; }
				})
				.css({
					position: 'absolute',
					top: 0,
					left: 0,
					zIndex: 8
				})
				.hide()
				.eq(active_num).css({
					position: 'relative'
				})
				.show();

			if(mouseStop === true) {
				// Bei MouseOver stoppen?
				var mouseStopTimeout;
				$(self).mouseenter(function(){
					if(autoStart === true){
						self.stop();
						clearTimeout(mouseStopTimeout);
					}
				});
				$(self).mouseleave(function(){
					if(autoStart === true){
						mouseStopTimeout = setTimeout((backward == true ? self.prev : self.next), delay);
					}
				});
			}

			// Touch-Event zum Verschieben
			$(self).bind('touchstart', function (e){
				touchLastX = e.originalEvent.touches[0].clientX;
				scrollLastY = $(window).scrollTop();
			});
			$(self).bind('touchend', function (e){
				var currentX = e.originalEvent.changedTouches[0].clientX;
				var scrollY = $(window).scrollTop();

				// Nur wenn die Seite nicht hoch oder runter geschoben wurde...
				if(scrollY == scrollLastY){
					if(currentX > touchLastX){
						// moved right
						self.prev();
					} else if(currentX < touchLastX){
						// moved left
						self.next();
					}
				}
				touchLastX = currentX;
				scrollLastY = scrollY;
			});

			$(buttonPage).each(function(i){
				if($(this).hasClass(buttonPageAct)) active_num = i;
				$(this).click(function(){
					var jto = $(this).attr('href').replace('#','');
					self.jumpTo(jto);
					return false;
				});
			});

			$(buttonStop).click(self.stop);
			$(buttonNext).click(self.next);
			$(buttonPrev).click(self.prev);
			self.checkNav();

			if(autoStart === true) {
				timeInterval = setTimeout(self.next, delay);
			}

		});
	};

	// Tasten-Steuerung
	$(document).bind('keydown',function(e){
		if(e.keyCode == 37){
			//e.preventDefault();
			$($.fn.mpfader.collection).each(function(i){
				if($.fn.mpfader.collection[i].key_navigation == true && $($.fn.mpfader.collection[i]).is(':visible')) $.fn.mpfader.collection[i].prev();
			});
		}
		if(e.keyCode == 39){
			//e.preventDefault();
			$($.fn.mpfader.collection).each(function(i){
				if($.fn.mpfader.collection[i].key_navigation == true && $($.fn.mpfader.collection[i]).is(':visible')) $.fn.mpfader.collection[i].next();
			});
		}
	});

	$.fn.mpfader.collection = [];

	$.fn.mpfader.defaults = {
		autoStart:		true,	// Start automatisch im Interval
		keyNavigation:	false,	// Tastaturnavigation über Pfeiltasten erlauben (zurück/weiter)
		delay:			5000,	// Dauer der Anzeige
		effectDuration:	500,	// Wechseldauer in ms
		fitHeight:		false,	// Höhe der Slideshow nach Inhalt anpassen (animiert)
		randomEffects:	['fade', 'slide-x', 'slide-y', 'fade', 'blind-x', 'blind-y'], // Mögliche Zufallseffekte
		effect:			'fade', // Übergangseffekt: fade, slide-x, slide-y, blind-x, blind-y, rand
		elements:		'> *',	// Bilder werden anhand diesem Selektor identifiziert (z.B. auch a.klasse möglich)
		buttonStop:     '.mpfader-stop', // Selektor oder Objekt für Click-Stop
		buttonNext:     '.mpfader-next', // Selektor oder Objekt für Click-Nächtes
		buttonPrev:     '.mpfader-prev', // Selektor oder Objekt für Click-Voriges
		buttonPage:     '.mpfader-page', // Selektor oder Objekt für Click-Voriges
		buttonPageAct:  'mpfader-page-active', // CSS-Klasse für aktiven Punkt
		mouseStop: 		false
	};

})(jQuery);



